import { render, staticRenderFns } from "./ProgramsCreate.vue?vue&type=template&id=0344ead3&scoped=true"
import script from "./ProgramsCreate.vue?vue&type=script&lang=js"
export * from "./ProgramsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344ead3",
  null
  
)

export default component.exports